interface NameTranslation {
  languageCode: string;
  name: string;
}

interface DescriptionTranslation extends NameTranslation {
  description: string;
}

/**
 * Resolve a server-side translated name for the active language, falling back
 * to the first available translation. This idiom was duplicated in six files.
 */
export const getTranslation = (
  translations: NameTranslation[] | undefined,
  language: string,
): string =>
  translations?.find((t) => t.languageCode === language)?.name ??
  translations?.[0]?.name ??
  "";

export const getTranslatedDescription = (
  translations: DescriptionTranslation[] | undefined,
  language: string,
): string =>
  translations?.find((t) => t.languageCode === language)?.description ??
  translations?.[0]?.description ??
  "";
